import React from 'react';
import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';
import { useStyletron } from 'styletron-react';
import { FileUploader } from 'baseui/file-uploader';
import { Button } from 'baseui/button';
import { Input } from 'baseui/input';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG } from './formConfig';
import useCampaignDetails from './useCampaignDetails';

const CampaignDetails: React.FC<{}> = () => {
	const {
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader,
		handleFileUpload,
		csvFile,
		uploadCsvFile,
		showAlert,
		csvCampaignName,
		setCsvCampaignName
	} = useCampaignDetails();
	const [css] = useStyletron();

	return (
		<div
			className={css({
				height: 'calc(100vh - 40px)',
				overflowY: 'scroll',
				padding: '20px',
				paddingBottom: '60px'
			})}>
			<div
				className={css({
					maxHeight: '35vh',
					marginBottom: '40px',
					paddingLeft: '20px'
				})}>
				<h3
					className={css({
						marginTop: '10px',
						marginBottom: '15px'
					})}>
					Add Campaign Data via Athena Query
				</h3>
				<FormBuilder
					data={EMPTY_OBJECT}
					mode='create'
					showLoader={showLoader}
					handleFormSubmit={handleFormSubmit}
					handleFormCancel={handleFormCancel}
					setShowLoader={setShowLoader}
					fieldConfig={FORM_FIELD_CONFIG}
					layoutConfig={FORM_LAYOUT_CONFIG}
					buttonLabels={{
						submitLabel: 'Submit',
						discardLabel: 'Back'
					}}
				/>
			</div>
			<div
				className={css({
					display: 'flex',
					flexDirection: 'column',
					marginTop: '0px',
					paddingLeft: '20px'
				})}>
				<h3
					className={css({
						marginBottom: '10px'
					})}>
					Add Campaign Data via CSV Upload
				</h3>
				<div
					className={css({
						width: '600px',
						marginBottom: '20px',
						padding: '15px',
						backgroundColor: '#f5f5f5',
						borderRadius: '8px'
					})}>
					<p
						className={css({
							margin: '0',
							fontSize: '14px',
							color: '#666',
							lineHeight: '1.5'
						})}>
						<strong>Important Notes:</strong>
						<ul
							className={css({
								marginTop: '8px',
								paddingLeft: '20px'
							})}>
							<li> Please ensure campaign is already created</li>
							<li>Only 1 CSV can be uploaded per campaign name</li>
							<li>CSV should not have more than 50k rows</li>
							<li>CSV should have only one column with header: zupeeUserId</li>
						</ul>
					</p>
				</div>
				<div
					className={css({
						marginBottom: '20px',
						width: '300px'
					})}>
					<div
						className={css({
							marginBottom: '8px',
							fontSize: '14px',
							fontWeight: 'bold',
							color: '#000000'
						})}>
						Campaign Name *
					</div>
					<Input
						value={csvCampaignName}
						onChange={(e) => setCsvCampaignName(e.currentTarget.value)}
						placeholder='Enter Campaign Name'
						required
						overrides={{
							Root: {
								style: {
									borderRadius: '8px',
									borderColor: '#6B6B6B',
									borderWidth: '2px'
								}
							},
							Input: {
								style: {
									fontSize: '14px',
									color: '#000000',
									'::placeholder': {
										color: '#666666',
										fontStyle: 'italic'
									}
								}
							}
						}}
					/>
				</div>
				<div
					className={css({
						display: 'flex',
						gap: '20px',
						alignItems: 'flex-start'
					})}>
					<div
						className={css({
							width: '500px',
							height: '200px',
							border: '1px dashed #ccc',
							padding: '20px'
						})}>
						<FileUploader
							accept={['.csv']}
							maxFiles={1}
							onDropRejected={() => {
								showAlert('Please upload only one CSV file', { type: 'error' });
							}}
							onDrop={(uploadedFiles) => handleFileUpload(uploadedFiles)}
							overrides={{
								FileDragAndDrop: {
									style: {
										borderColor: 'purple',
										borderRadius: '10px',
										width: '100%',
										height: '100%'
									}
								}
							}}
						/>
					</div>
					{csvFile && (
						<div
							className={css({
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'flex-start',
								marginTop: '10px'
							})}>
							<p>File: {csvFile.name}</p>
							<Button
								onClick={uploadCsvFile}
								disabled={!csvFile || !csvCampaignName.trim()}
								overrides={{
									BaseButton: {
										style: {
											width: '120px',
											marginTop: '10px',
											borderRadius: '20px',
											':hover': {
												backgroundColor: 'green'
											},
											':active': {
												backgroundColor: 'green'
											}
										}
									}
								}}>
								Upload CSV
							</Button>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default CampaignDetails;
